export default {"src":"/_next/static/media/promo.529e9627.svg","height":36,"width":56,"blurWidth":0,"blurHeight":0};